import { Helper } from '@/services/helper/helper'

export default class TPID {
  constructor () {
    this.cookieName = 'tp_id'

    if (document.cookie.split(';').some((item) => item.trim().startsWith(`${this.cookieName}_reload=`))) { return }

    this.requestUrl = Helper.isLiveStage() ?
      'https://einwilligungsspeicher.netid.de/netid-subject-identifiers?q.tapp_id.eq=ef48100e-ab6f-41e8-9dbb-2c3c35b9c7f9' :
      'https://einwilligungsspeicher.qa.netid.de/netid-subject-identifiers?q.tapp_id.eq=89c21b99-dfb9-4215-8c10-a22521c03878'

    const headers = {
      'Accept': 'application/vnd.netid.permission-center.netid-tpid-subject-v1+json'
    }

    fetch(this.requestUrl, { method: 'GET', headers, credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        if (!data.tpid) { return }

        document.cookie = `${this.cookieName}=${data.tpid}; domain=${window.SiteInfo.brandShort}.${window.SiteInfo.tld}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=None; Secure;`
        document.cookie = `${this.cookieName}_reload=; domain=${window.SiteInfo.brandShort}.${window.SiteInfo.tld}; path=/; max-age=${60 * 60 * 24 * 2}; SameSite=None; Secure;`
      }).catch(e => {})
  }
}